import conditionSection from "../../components/conditionSection/index.vue";
import newsLetters from "../../components/newsLetters/index.vue";
import partenairesSection from "../../components/partenairesSection/index.vue";
import heroSection from "../../components/heroSection/index.vue";

export default {
  name: "conditionPage",
  components: {
    heroSection,
    conditionSection,
    newsLetters,
    partenairesSection
  },
  methods: {
    track() {
      this.$gtag.screenview({
        screen_name: 'Conditions page',
      })
      this.$gtag.pageview({
        page_path: '/conditions',
      })
    }
  }
};
